module.exports = __webpack_public_path__ + "img/image26.f24c2386.jpg";